import React, { useEffect, useState } from 'react';
import {defaultStatusColumns, GateColumns, shouldDisable} from './status.utils';
import StatusTable from './statusTable/index.js';
import { Col, Radio, Row } from 'antd';
import IpsDTCommentsIcon from 'components/CommentsIcon/IpsDTCommentsIcon';
import {isAdministrator, isIPSAdministrator, isIPSDataCreatorOrAdministrator} from 'utils/UserInfo';

function FundedView(props) {
  const {
    project,
    handleProjectDetailUpdate,
    comments,
    isReadOnly,
    locDropDownOptions,
    phaseDetails,
    phaseId,
    isProjectOnHold,
  } = props;

  const [fundedDropdownOptions, setFundedDropdownOptions] = useState([]);

  useEffect(() => {
    if (phaseDetails?.locSheetStatus !== null) {
      let options = [];
      let index = locDropDownOptions.indexOf(phaseDetails?.locSheetStatus);
      // We are checking here if we have status 'IPS Locations Created then we will show 2 options
      if(index < 6) options.push(locDropDownOptions[index+1]);
      if(index === 0) options.push(locDropDownOptions[4]);
      if(index === 3) options.push(locDropDownOptions[6]);
      if(index <= 5 && index > 0) options.push(locDropDownOptions[index-1]);
      if(index == 4) options.push(locDropDownOptions[0]);
      if(index == 6) {
        options.push(locDropDownOptions[3]);
        options.push(locDropDownOptions[4]);
      }
      setFundedDropdownOptions(options);
    }
    else {
      setFundedDropdownOptions([locDropDownOptions[0]]);
    }
  }, [phaseDetails?.locSheetStatus, locDropDownOptions]);
  
  return (
    <div>
      <section className='padding-container'>
        <Row justify='end' align='middle' gutter={25}>
          <Col className='d-flex flex-column'>
          <div className='d-flex flex-row'>
            <span className='key-title pr-1'>CCA SLA:</span>
              {phaseDetails?.locSheetSLA && ` ${phaseDetails?.locSheetSLA}`}
          </div>
          </Col>
          <Col>
            <IpsDTCommentsIcon
              project={project}
              commentGroup={'FUNDED'}
              comments={comments}
              phase={phaseId}
            />
          </Col>
        </Row>
        <Row>
          <Col
            xs={{
              span: 24,
            }}
            sm={{
              span: 24,
            }}
            md={{
              span: 24,
            }}
            lg={{
              span: 12,
            }}
            xxl={{
              span: 12,
            }}
          >
            <Row className='spacing-bottom'>
              <Col
                className='key-title'
                xs={{
                  span: 5,
                }}
                sm={{
                  span: 5,
                }}
                md={{
                  span: 5,
                }}
                lg={{
                  span: 6,
                }}
                xxl={{
                  span: 4,
                }}
              >
                Funded
              </Col>
              <Col>
                <Radio.Group
                  onChange={(e) => {
                    let value = e.target.value;
                    handleProjectDetailUpdate(value, 'FUNDED_FLAG', 'string',phaseId);
                  }}
                  style={{ display: 'inline-flex' }}
                  id={'gate-asset-check'}
                  defaultValue={'N'}
                  options={[
                    { label: 'Yes', value: 'Y' },
                    { label: 'No', value: 'N' },
                  ]}
                  value={phaseDetails?.fundedFlag}
                  disabled={
                    isReadOnly ||isProjectOnHold||
                    shouldDisable(phaseDetails?.fundedFlag === 'Y')
                  }
                />
              </Col>
            </Row>
            <Row className='spacing-bottom'>
              <Col
                className='key-title'
                xs={{
                  span: 5,
                }}
                sm={{
                  span: 5,
                }}
                md={{
                  span: 5,
                }}
                lg={{
                  span: 6,
                }}
                xxl={{
                  span: 4,
                }}
              >
                {''}
              </Col>
              {phaseDetails && phaseDetails.fundedChangedDate && (
                <Col>{`${phaseDetails.fundedChangedUser}  ${phaseDetails.fundedChangedDate}`}</Col>
              )}
            </Row>
          </Col>

          <Col
            xs={{
              span: 24,
            }}
            sm={{
              span: 24,
            }}
            md={{
              span: 24,
            }}
            lg={{
              span: 12,
            }}
            xxl={{
              span: 12,
            }}
          >
          </Col>
        </Row>
        <StatusTable
          dataSource={phaseDetails?.locSheetHistory}
          dropOptions={fundedDropdownOptions}
          disabledButtons={
            isReadOnly ||isProjectOnHold||
            phaseDetails?.fundedFlag === 'N' ||
            shouldDisable(
              
              phaseDetails?.locSheetStatus === locDropDownOptions[locDropDownOptions?.length -1]
            )
          }
          fieldName = {'LOC_SHEET_STATUS'}
          currentStatus = {phaseDetails.locSheetStatus}
          phaseId = {phaseId}
          handleProjectDetailUpdate = {handleProjectDetailUpdate}
          disableDelete = {project.trackerStatus === 'DT_C' ? true : false}
        />
      </section>
    </div>
  );
}
export default FundedView;
